'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _index = require('../../index');

//
//
//
//
//
//
//
//
//
//
//

var dom = weex.requireModule('dom');
var animation = weex.requireModule('animation');
exports.default = {
  props: {
    listArray: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    itemIndex: {
      type: Number,
      default: null
    },
    wrapHeight: {
      type: Number,
      default: 408
    },
    wrapWidth: {
      type: Number,
      default: 710
    },
    isShowIndicator: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    raduisType: {
      type: String,
      default: 'all'
    },
    labelOffset: {
      type: Number,
      default: null
    },
    align: {
      type: String,
      default: 'center' // 'center'/'left'
    }
  },
  data: function data() {
    return {
      isInit: false,
      itemHeight: 81,
      index: this.itemIndex,
      handler: null,
      intervalHandler: null
    };
  },


  computed: {
    wrapStyle: function wrapStyle() {
      return {
        // width: this.wrapWidth,
        height: this.wrapHeight
      };
    },
    selectedItemTop: function selectedItemTop() {
      return Math.floor(this.wrapHeight / this.itemHeight / 2) * this.itemHeight;
    },
    indicatorStyle: function indicatorStyle() {
      var raduisType = this.raduisType;

      var indicatorStyle = {
        top: this.selectedItemTop + 'px',
        width: this.wrapWidth,
        height: this.itemHeight + 2
      };
      var selectAreaRadius = {};
      if (raduisType == 'all') {
        selectAreaRadius = { borderRadius: '16px' };
      } else if (raduisType == 'mid') {
        selectAreaRadius = {
          borderRadius: 0
        };
      } else if (raduisType == 'left') {
        selectAreaRadius = {
          borderTopLeftRadius: '16px',
          borderBottomLeftRadius: '16px'
        };
      } else {
        selectAreaRadius = {
          borderTopRightRadius: '16px',
          borderBottomRightRadius: '16px'
        };
      }
      return _extends({}, selectAreaRadius, indicatorStyle);
    },
    labelStyle: function labelStyle() {
      return {
        top: this.selectedItemTop + 'px',
        left: this.labelOffset ? this.labelOffset : this.wrapWidth / 2 + 50,
        width: this.wrapWidth / 2,
        height: this.itemHeight
      };
    },
    scrollerStyle: function scrollerStyle() {
      return {
        width: this.wrapWidth,
        height: this.wrapHeight
      };
    },
    itemStyle: function itemStyle() {
      return {
        // width: this.wrapWidth
      };
    },
    calcListArray: function calcListArray() {
      var _this = this;

      var result = [];
      result = this.listArray.map(function (item, index) {
        item['classes'] = [];
        item['refs'] = []; // add by lau
        if (_this.align == 'left' && _this.label) {
          item['classes'].push('list-item-left');
        }
        // 添加类设置外边距以解决首尾两项选中时的位置偏移，style
        if (index == 0) {
          item['classes'].push('first-item');
        } else if (index == _this.listArray.length - 1) {
          item['classes'].push('last-item');
        }

        if (index == _this.itemIndex - 2) {
          item['classes'].push('first-visible-item');
          item['refs'].push('first-visible-item');
        } else if (index == _this.itemIndex - 1) {
          item['classes'].push('second-visible-item');
        } else if (index == _this.itemIndex) {
          item['classes'].push('selected-item');
        } else if (index == _this.itemIndex + 1) {
          item['classes'].push('second-last-visible-item');
        } else if (index == _this.itemIndex + 2) {
          item['classes'].push('first-last-visible-item');
          item['refs'].push('first-last-visible-item');
        }
        return item;
      });
      return result;
    }
  },

  watch: {
    itemIndex: function itemIndex(value) {
      this.index = value;
    }
  },
  methods: {
    scroll: function scroll(event) {
      var _this2 = this;

      if (!this.isInit) return;
      // 计算当前滚动到的下标,  滚动距离/item高度
      this.itemIndex = Math.abs(Math.round((event.contentOffset.y || 0) / this.itemHeight));
      // Core.toast(event.contentOffset.y)
      if (weex.config.env.platform == 'android') {
        if (this.handler) {
          clearTimeout(this.handler);
        }
        this.handler = setTimeout(function () {
          _this2.handleEnd(event);
        }, 500);
      }
    },
    handleEnd: function handleEnd(e) {
      var _this3 = this;

      if (!this.isInit) return;
      // 计算当前滚动到的下标
      setTimeout(function () {
        _this3.scrollToIndexItem(_this3.itemIndex);
        _this3.$emit('onChange', _this3.listArray[_this3.itemIndex]);
      }, 400);
    },


    // 滚动到item下标所在的位置
    scrollToIndexItem: function scrollToIndexItem(index) {
      var _this4 = this;

      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var el = this.$refs.item[index];
      if (el) {
        dom.getComponentRect(el, function (options) {
          if (options.result && options.size.bottom) {
            dom.scrollToElement(el, { animated: animated, offset: index == 0 ? 0 : -_this4.selectedItemTop });
            _this4.isInit = true;
          } else {
            setTimeout(function () {
              return _this4.scrollToIndexItem(index, animated);
            }, 100);
          }
        });
      }
    },


    // 特效处理 => css
    modifyItemStyle: function modifyItemStyle(index) {
      var el = this.$refs['first-visible-item'];
      animation.transition(el, {
        styles: {
          transform: 'rotateX(60deg)',
          perspective: 100,
          transformOrigin: 'center center'
        },
        duration: 10, //ms
        timingFunction: 'ease',
        needLayout: false,
        delay: 0 //ms
      }, function () {});
    }
  },
  mounted: function mounted() {
    if (this.itemIndex != null) {
      this.scrollToIndexItem(this.itemIndex, false);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-picker/picker.vue
// module id = 361
// module chunks = 0 1